import { render, staticRenderFns } from "./add-share-select-item.vue?vue&type=template&id=17374045&"
import script from "./add-share-select-item.js?vue&type=script&lang=js&"
export * from "./add-share-select-item.js?vue&type=script&lang=js&"
import style0 from "./add-share-select-item.css?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardActions,VCardText,VSwitch})
